<template>
  <v-form @submit.prevent="addEditProjectTask" ref="form">
     <v-card dense style="border-radius:4px;">
        <v-toolbar flat height="45px">
            <span class="font-weight-bold ">Add Project</span>
            <v-spacer></v-spacer>
            <help-link appId="projects" pageId="project-charges-weekly" color="black"></help-link>
            <v-btn icon @click.native="closeDialog" :disabled="loading" >
                <v-icon >close</v-icon>
            </v-btn>
        </v-toolbar>
        <p v-if="error" style="color:red;">{{ errorMessage }}</p>
        <v-card-text>
            <v-toolbar flat height="45px">
                <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details style="margin-bottom:15px;"></v-text-field>
            </v-toolbar> 
            <v-data-table
                :headers="headers_project"
                :items="projects_filtered"
                :loading="loading"
                :expand="expand" 
                item-key="projectId"
            >
                <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                <template v-slot:items="props">
                    <tr style="cursor:pointer;" @click="props.expanded = !props.expanded" title="Click to view project tasks">
                        <td><span class="font-weight-bold">{{ props.item.projectCode }}</span></td>
                        <td><span class="font-weight-bold">{{ props.item.client }}</span></td>
                        <td><span class="font-weight-bold">{{ props.item.projectName }}</span></td>
                    </tr>
                </template>
                <template v-slot:expand="props"> 
                    <v-data-table
                        :headers="headers_task"
                        :items="props.item.projectTasks"
                        hide-actions
                    >
                        <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                        <template v-slot:items="props2">
                            <tr @click="addProjectTask(props2.item, props.item)" title="Click to add" style="cursor:pointer;" >
                                <td>{{ props2.item.taskCode }}</td>
                                <td>{{ props2.item.taskName }}</td>
                                <td>{{ props2.item.taskDescription }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                </template>
            </v-data-table>
        </v-card-text>  
    </v-card>
  </v-form>
</template>
<script>

import projectsApi from '@/api/projects'
import commonfn from '@/common/functions'

export default {
    name: 'AddProject',
    data () {
        return {
            error: false,
            errorMessage: '', 
            loading: false,
            error: false,  
            headers_project: [
                {text: 'Project Code',align: 'left',value: '', width:'20%', sortable:false},
                {text: 'Client',align: 'left',value: '', sortable:false},
                {text: 'Project Name',align: 'left',value: '', sortable:false},
            ],
            headers_task: [
                {text: 'Task Code',align: 'left',value: '', width:'20%', sortable:false},
                {text: 'Task Name',align: 'left',value: '', sortable:false},
                {text: 'Task Description',align: 'left',value: '', sortable:false},
            ],
            expand: false,
            search: null,
            projects: [],
            cutoffId: null

        }
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },
    methods: {    
        addProjectTask(taskData, projectData) {
            var data = {
                projectId: projectData.projectId,
                projectKey: projectData.projectKey,
                projectCode: projectData.projectCode,
                client: projectData.client,
                projectName: projectData.projectName,
                isAdminProject: projectData.isAdminProject,
                projectTaskId: taskData.projectTaskId,
                projectTaskKey: taskData.projectTaskKey,
                taskCode: taskData.taskCode,
                taskName: taskData.taskName,
                taskDescription: taskData.taskDescription                
            }
            this.$emit('send', data)
            this.closeDialog()
        },
        async getProjects() {
            try {                
                this.loading = true
                const response = await projectsApi.get(true) //include admin projects
                if (response && response.status == 200) {
                    this.projects = response.data.items.filter(x => x.status != commonfn.getStatusCode('Completed'))
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        closeDialog() {
            this.$emit('update:dialogAddProject', false)
        },
    },
    computed: {
        projects_filtered() {
            var temp = JSON.parse(JSON.stringify(this.projects)) //deep clone
            if (this.search) {
                temp = temp.filter(item => {
                    return (
                        item.projectKey.toLowerCase().includes(this.search.toLowerCase()) ||
                        item.projectName.toLowerCase().includes(this.search.toLowerCase()) ||
                        item.projectTasks.filter(task => {
                            return (
                                task.projectTaskKey.toLowerCase().includes(this.search.toLowerCase()) ||
                                task.taskName.toLowerCase().includes(this.search.toLowerCase())
                            )
                        }).length>0
                    )
                })
                if (temp.length) {
                    temp.forEach(item => {
                        item.projectTasks = item.projectTasks.filter(x => {
                            return (
                                x.projectTaskKey.toLowerCase().includes(this.search.toLowerCase()) ||
                                x.taskName.toLowerCase().includes(this.search.toLowerCase())
                            ) 
                        })
                    })
                }
            }
            return temp
        }
    },
    created() {
        this.commonfn = commonfn
    }
}
</script>